export default __webpack_public_path__ + "static/media/VdS-Webseite-Quicklinks-Icon.54c998e7.svg";